import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    selectionStartEnd: {
        color: "White",
        backgroundColor: "Black",
    },
    middleRange: {
        color: "Black",
        backgroundColor: "#EDEFF2",
    },
    firstSelectionBackGround: {
        backgroundColor: "#EDEFF2",
        borderRadius: "40px 0px 0px 40px",
    },
    lastSelectionBackGround: {
        backgroundColor: "#EDEFF2",
        borderRadius: "0px 40px 40px 0px",
    },
}));
